const defaultState = {
  code: null,
  verifying: false,
  verified: false,
  valid: false,
  message: null
};

export default function coupon(state = defaultState, action) {
  switch (action.type) {
    case "CHANGE_COUPON": {
      return defaultState;
    }
    case "VERIFY_COUPON": {
      return {
        ...defaultState,
        verifying: true
      };
    }
    case "VERIFY_COUPON_SUCCESS": {
      const { coupon: cp, valid, message } = action;
      return {
        ...state,
        verifying: false,
        verified: true,
        valid,
        message,
        ...cp
      };
    }
    case "VERIFY_COUPON_FAILURE": {
      return {
        ...state,
        error: action.error,
        verifying: false
      };
    }
    case "REMOVE_COUPON":
    case "CHECKOUT_SUCCESS":
      return defaultState;
    case "TOGGLE_CART": {
      if (!action.bool && !state.valid) return defaultState;
      return state;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/coupon.js